//      

// is a value between two other values

export default (
  lowerBound        ,
  upperBound        ,
)                        => (value        )          =>
  lowerBound <= value && value <= upperBound;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/is-within.js